import { Base } from "@studiometa/js-toolkit";
import { domScheduler } from "@studiometa/js-toolkit/utils";
class EditorVisibility extends Base {
  /**
   * Config.
   */
  static config = {
    name: "EditorVisibility"
  };
  show() {
    domScheduler.write(() => {
      this.$el.style.display = "";
    });
  }
  hide() {
    domScheduler.write(() => {
      this.$el.style.display = "none";
    });
  }
  toggle(force) {
    if (force === true) {
      this.show();
      return;
    }
    if (force === false) {
      this.hide();
      return;
    }
    domScheduler.read(() => {
      if (this.$el.style.display === "none") {
        this.show();
      } else {
        this.hide();
      }
    });
  }
}
export {
  EditorVisibility as default
};
//# sourceMappingURL=EditorVisibility.js.map
